import React from "react";

const MaterialTotalTable = ({ data, title }) => {
  return (
    <div className="bg-white border border-slate-200 shadow-sm rounded-xl h-full flex flex-col">
      <h2 className="text-lg font-semibold p-4 border-b border-slate-200 text-slate-800">
        {title}
      </h2>
      <div className="flex-1 overflow-hidden">
        <div className="overflow-auto ">
          <table className="min-w-full text-left">
            <thead className="sticky top-0 bg-slate-100">
              <tr>
                <th className="py-3 px-4 text-sm font-semibold text-slate-700 border-b border-slate-200">
                  Material Description
                </th>
                <th className="py-3 px-4 text-sm font-semibold text-slate-700 border-b border-slate-200">
                  Count
                </th>
              </tr>
            </thead>

            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td
                    colSpan="2"
                    className="py-6 text-center text-slate-500 italic"
                  >
                    No data found
                  </td>
                </tr>
              ) : (
                data.map((item, index) => (
                  <tr
                    key={index}
                    className={`border-b ${
                      index % 2 === 0 ? "bg-slate-50" : "bg-white"
                    } hover:bg-slate-100`}
                  >
                    <td className="py-3 px-4 text-slate-700 text-sm font-medium">
                      {item?.name}
                    </td>
                    <td className="py-3 px-4 text-slate-700 text-sm font-medium">
                      {item?.count}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MaterialTotalTable;
